import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
const services = [{
  title: 'Representation & Advisory',
  description: 'Full-service representation from youth hockey (U10) all the way to procuring contracts in junior, college, and professional leagues.',
  highlight: 'Contract Negotiation'
}, {
  title: 'Player ID Camps',
  description: "Intensive evaluation camps providing detailed, honest assessments of a player's current skill level and what is required to advance.",
  highlight: 'Honest Evaluation'
}, {
  title: 'Recruiting & Team Analysis',
  description: "In-depth analysis of potential teams and leagues to ensure the perfect fit for a player's development style and career goals.",
  highlight: 'Strategic Placement'
}, {
  title: 'Pathway Planning',
  description: "Customized development roadmaps. We don't just build Plan A; we build Plan B and C so players are prepared for any scenario.",
  highlight: 'Multi-Route Strategy'
}, {
  title: 'Mental Performance',
  description: 'Guidance through the toughest parts of the game. We provide transition support and resilience training for trades, cuts, and injuries.',
  highlight: 'Resilience Training'
}, {
  title: 'Network Access',
  description: 'Direct connections with junior, college, and pro coaches, GMs, and owners across North America and Overseas.',
  highlight: 'Global Connections'
}];
export const ServicesSection = () => {
  return <section id="services" className="py-24 bg-navy-900 relative border-t border-navy-800" data-id="element-185">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-186">
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6" data-id="element-187">
          <div className="max-w-2xl" data-id="element-188">
            <motion.h2 initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} className="text-4xl md:text-5xl font-bold text-white mb-4 uppercase tracking-tight" data-id="element-189">
              What We <span className="text-gold-500" data-id="element-190">Do</span>
            </motion.h2>
            <motion.p initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-100px'
          }} transition={{
            delay: 0.1
          }} className="text-lg text-slate-300" data-id="element-191">
              Comprehensive development and representation that provides you
              with the tools needed to get to the next level and thrive in every
              environment.
            </motion.p>
          </div>
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.6
        }} className="hidden md:block w-64 h-40 rounded-sm overflow-hidden border border-navy-700 shrink-0 bg-navy-700" data-id="element-192">
            <img src="https://cdn.magicpatterns.com/uploads/nbmfKvVQf3C63DhJVuHC33/5747.png" alt="Player development on ice" className="w-full h-full object-cover object-center" data-id="element-193" />
          </motion.div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-194">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 30
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-50px'
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="group relative bg-navy-800 p-8 md:p-10 rounded-sm overflow-hidden border border-navy-700 hover:border-ice-500 transition-all duration-300 hover:-translate-y-1" data-id="element-195">
              {/* Subtle background accent on hover */}
              <div className="absolute top-0 right-0 w-64 h-64 bg-ice-500/5 rounded-full blur-3xl -mr-32 -mt-32 transition-opacity opacity-0 group-hover:opacity-100" data-id="element-196"></div>

              <div className="relative z-10" data-id="element-197">
                <span className="text-xs font-bold tracking-widest text-ice-500 uppercase mb-4 block" data-id="element-198">
                  {service.highlight}
                </span>
                <h3 className="text-2xl font-bold text-white mb-4 group-hover:text-ice-400 transition-colors" data-id="element-199">
                  {service.title}
                </h3>
                <p className="text-slate-300 leading-relaxed mb-8" data-id="element-200">
                  {service.description}
                </p>

                <a href="#contact" className="flex items-center text-sm font-bold text-white group-hover:text-gold-500 transition-colors" data-id="element-201">
                  Learn more
                  <ArrowRight className="ml-2 w-4 h-4 transform group-hover:translate-x-1 transition-transform" data-id="element-202" />
                </a>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
};